import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorLpYields = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M12 20.25a8.25 8.25 0 0 0 7.566-11.544.75.75 0 1 1 1.375-.6l.044.102A9.723 9.723 0 0 1 21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25a.75.75 0 0 1 0 1.5 8.25 8.25 0 1 0 0 16.5Z"
    />
    <path
      fill="#F7A600"
      d="M17.75 2.75a.75.75 0 0 0-1.5 0v1.5h-1.5a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5v-1.5ZM7.6 9.3v6.25h3.742v-1.21H8.961V9.3H7.6ZM12.348 9.3v6.25h1.36v-2.257h1.594c.293 0 .555-.048.788-.143.233-.102.43-.239.59-.412a1.76 1.76 0 0 0 .386-.627c.09-.244.134-.516.134-.814 0-.293-.045-.562-.134-.806a1.746 1.746 0 0 0-.385-.636 1.652 1.652 0 0 0-.591-.403 1.953 1.953 0 0 0-.788-.152h-2.954Zm2.793 2.811h-1.433v-1.63h1.433c.203 0 .361.055.474.162.12.101.18.254.18.457v.393c0 .204-.06.359-.18.466-.113.101-.271.152-.474.152Z"
    />
  </svg>
);
export default SvgTwoColorLpYields;
